import types from "../types";

const initial = { orders: [], totalPages: 1 };

export const order_reducer = (state = initial, { type, payload }) => {
  switch (type) {
    case types.ORDER:
      return {
        ...state,
        orders: payload.orders,
        totalPages: payload.totalPages,
      };

    case types.ORDER_RESET:
      return initial;

    case types.AUTH_RESET:
      return initial;

    default:
      return state;
  }
};
